// This file is auto-generated. Run `pnpm generate:icons` to regenerate.
// biome-ignore-all assist/source/organizeImports: Generated file.
// biome-ignore-all format: Generated file.
// biome-ignore-all lint/a11y/noSvgWithoutTitle: Icon accessibility is handled by the Icon wrapper.
import type { SVGProps } from "react";

export default function CircleInfoIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}><path d="M 10.9 6.5 H 13.1 V 8.7 H 10.9 V 6.5 Z M 10.9 10.9 H 13.1 V 17.5 H 10.9 V 10.9 Z M 12 1 C 5.928 1 1 5.928 1 12 C 1 18.072 5.928 23 12 23 C 18.072 23 23 18.072 23 12 C 23 5.928 18.072 1 12 1 Z M 12 20.8 C 7.149 20.8 3.2 16.851 3.2 12 C 3.2 7.149 7.149 3.2 12 3.2 C 16.851 3.2 20.8 7.149 20.8 12 C 20.8 16.851 16.851 20.8 12 20.8 Z" fill="currentColor" />
</svg>
  );
}